module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-29.c2c0847e.svg";